import React, { useState } from 'react'

import Database from '../../types/Database'
import CreateDesk from '../desk/CreateDesk'

import WizardPointer from './WizardPointer'

interface CreateDeskStepProps {
  user: Database.User
  preSelectedOffice: Database.Office
  onSuccess: () => void
  onCancel: () => void
}

/**
 * CreateDeskStep - Wrapper component for desk creation within onboarding wizard
 *
 * Wraps the existing CreateDesk component and integrates it into the wizard flow.
 * Features:
 * - Pre-selects the newly created office
 * - Disables office selection dropdown
 * - Shows pointer on first visit for guidance
 * - Intercepts onCreate callback to complete onboarding
 * - Handles cancel to return to desk prompt
 *
 * Requirements: 6.1, 6.2, 6.3, 6.4, 6.5, 10.2
 */
const CreateDeskStep: React.FC<CreateDeskStepProps> = ({
  user,
  preSelectedOffice,
  onSuccess,
  onCancel
}) => {
  const [showPointer, setShowPointer] = useState(true)

  const handleDeskCreated = () => {
    // Complete onboarding when desk is successfully created
    onSuccess()
  }

  const handleCancel = () => {
    // Return to desk creation prompt
    onCancel()
  }

  const handleDismissPointer = () => {
    setShowPointer(false)
  }

  return (
    <>
      <CreateDesk
        user={user}
        desk={null}
        onCreate={handleDeskCreated}
        onUpdate={() => {}}
        preSelectedOffice={preSelectedOffice}
        onCancel={handleCancel}
      />

      {/* Show pointer on first visit to guide user */}
      <WizardPointer
        target='#deskName'
        content='Enter a name for your first desk. This could be a desk number, location, or any identifier that makes sense for your office.'
        placement='bottom'
        visible={showPointer}
        onDismiss={handleDismissPointer}
      />
    </>
  )
}

export default CreateDeskStep
